import React, {Component} from 'react';
import {BrowserRouter, Switch} from 'react-router-dom';
import './App.css';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css'
import Login from './views/Login/Login';
import ForgotPasswordComponent from "./views/Profile/ForgotPasswordComponent"
import UpdatePasswordComponent from "./views/Profile/UpdatePasswordComponent";

import {
  getLoginCookie,
  hasUser,
  isAuthenticated,
  loginWithBasicAuth
} from './services/UserSessionService';
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import Loadable from "react-loadable";
import LoadablePlaceHolder from "./components/LoadingComponent";
import LoadingSpinnerComponent from "./components/LoadingSpinnerComponent";

const LoadableDefaultLayout = Loadable({
  loader: () => import('containers/DefaultLayout'),
  loading: LoadablePlaceHolder
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: isAuthenticated(),
      loading: true
    };
    this.userHasAuthenticated = this.userHasAuthenticated.bind(this);
  }


  componentDidMount(){
    if(hasUser()){
      this.setState({
        loading:false
      });
    }
    else{
      let loginCookie = getLoginCookie();
      if(loginCookie){
        loginWithBasicAuth(loginCookie, ()=>{
          this.setState({
            loading: false,
            isAuthenticated: isAuthenticated()
          });
        });

      }else{
        this.setState({
          loading:false
        });
      }

    }
  }


  userHasAuthenticated() {
    this.setState({isAuthenticated: isAuthenticated()});
  }

  render() {

    if (this.state.loading) return <LoadingSpinnerComponent/>

    let appProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated
    }

    return (
      <BrowserRouter>
        <Switch>
          <UnauthenticatedRoute exact path="/login" component={Login} props={appProps}/>
          <UnauthenticatedRoute exact path="/forgot-password" component={ForgotPasswordComponent} props={appProps}/>
          <AuthenticatedRoute exact path="/update-password" component={UpdatePasswordComponent} props={appProps}/>
          <AuthenticatedRoute path="/" name="Home" component={LoadableDefaultLayout} props={appProps}/>
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js